import dayjs, { Dayjs } from 'dayjs'
import {useEffect, useState} from 'react'
import {Container, Row, Table} from 'react-bootstrap'
import 'dayjs/plugin/isoWeek'
import { Customer } from '../../model/Customer'
import { CustomersResponseDTO } from '../../model/ResponsesDTO'
import { ProviderValue, useAxios } from '../../config/axios-config'
import './style.css'
import { PageLoader } from '../util/PageLoader'
import { Chip, Pagination, Stack } from '@mui/material'
import { DinneyObject } from '../../model/DinneyObject'
import isoWeek from 'dayjs/plugin/isoWeek'
import { MealDateWeekSelectionComponent } from './MealDateWeekSelectionComponent'
import { MonthPickerComponent } from './MonthPickerComponent'
import { FilterComponent } from './FilterComponent'
import { MealSelectionForSingleCustomerComponent } from './MealSelectionForSingleCustomerComponent'
import { SendToComponent } from './SendToComponent'
import {Empty, SelectProps} from 'antd'
import { EmptyContent } from '../util/EmptyContent'
import { isMobile } from 'react-device-detect'
import { ErrorPage } from '../error/ErrorPage'
import { SendStream } from '../util/SendStream'
import {DinneyUtil} from "../util/DinneyUtil";
import {useAuth0} from "@auth0/auth0-react";

dayjs.extend(isoWeek)

export const MealSelectionPage = () => {

    const {
        user,
    } = useAuth0();

    const axiosInstance = useAxios() as ProviderValue
    const [customersList, setCustomersList] = useState<Customer[]>([])
    const [filteredCustomersList, setFilteredCustomersList] = useState<Customer[]>([])
    const [isLoaded, setIsLoaded] = useState<boolean>(false)
    const [isError, setIsError] = useState<boolean>(false)
    const [isEmpty, setIsEmpty] = useState<boolean>(false)
    const [monthSwitcher, setMonthSwitcher] = useState<boolean>(true)
    const [pickedDate, setPickedDate] = useState<Dayjs>(dayjs().locale('pl'))
    const [page, setPage] = useState<number>(1)
    const [count, setCount] = useState<number>(0)
    const [billingTotal, setBillingTotal] = useState<number>(0)
    const [billingTotalAmount, setBillingTotalAmount] = useState<number>(0)
    const [customerIdsList, setCustomerIdsList] = useState<number[]>([])
    const [options, setOptions] = useState<SelectProps['options']>([]);
    const controller = new AbortController();
    const signal = controller.signal

    useEffect(() => {
        axiosInstance.get<CustomersResponseDTO>(`/customers/secure/fetch/allinmonth/${pickedDate.format('YYYY-MM-DD')}`, {signal})
        .then(response => {
            if (response.status === 204) {
                setIsEmpty(true)
            } else {
                setIsEmpty(false)
                handleSort(true, response.data.customersWithMealDates)
                setBillingTotal(response.data.customersWithMealDates.flatMap(cm=>cm.billings.filter(billing => dayjs(billing.datePeriod).month()+1 === pickedDate.month()+1)).reduce((a,v)=> a = a+v.billingTotal,0))
                setBillingTotalAmount(response.data.customersWithMealDates.flatMap(cm=>cm.billings.filter(billing => dayjs(billing.datePeriod).month()+1 === pickedDate.month()+1)).reduce((a,v)=> a = a+v.billingTotalAmount,0))
            }
            setIsLoaded(true) 
        }).catch((e : any) => {
            console.log(e.response?.data?.message === undefined ? e : e.response?.data?.message)
            setIsLoaded(true)
            setIsError(true)
        })
        return () => {
            controller.abort()
          }
    // eslint-disable-next-line
    },[monthSwitcher])

    const handleFillOptions = (customers : Customer[]) => {
        let tempOptions : SelectProps['options']= []
        customers.forEach(customer => {
            if (customer.customerMeals !== undefined && customer.customerMeals.length > 0 && customer.email !== "Brak") {
               tempOptions!.push({
                value: customer.customerid,
                label: `${customer.firstName} ${customer.lastName}`
            }) 
            }
        })
        setOptions(tempOptions)
    }

    const handleSort = (descending: boolean, list? : DinneyObject[]) => {
        let listToSort = list as Customer[] === undefined ? customersList : list as Customer[]
        let sortedCustomersList = [...listToSort!].sort((a,b) => {
            return DinneyUtil.setOrder(a.position, b.position,
                a.customerid, b.customerid, descending)
        })

        handleFillOptions(sortedCustomersList)
        setCustomersList(sortedCustomersList)
        setFilteredCustomersList(sortedCustomersList)
        setCount(Math.ceil(sortedCustomersList.length/10))
    }

    if (!isLoaded) {
        return (
            <PageLoader />
        )
    }
    if (isError) {
        return (
            <ErrorPage />
        )
    }

    if (isEmpty) {
        return (
            <>
                {!user?.dinneyroles.includes(process.env.REACT_APP_DINNEY_ROLE_PARENT) &&
                    <MonthPickerComponent
                        pickedDate ={pickedDate}
                        setPickedDate={setPickedDate}
                        setIsLoaded={setIsLoaded}
                        setMonthSwitcher={setMonthSwitcher}
                        isParent={false}
                    />
                }
            <EmptyContent message={'Aby móc zobaczyć tę stronę należy dodać przynajmniej jednego rodzica'}/>
            </>
        )
    }

    return (
    <>
    {user?.dinneyroles.includes(process.env.REACT_APP_DINNEY_ROLE_PARENT) &&
        <Stack gap={2} className="col-md-6 mx-auto mb-3">
            <MonthPickerComponent
                pickedDate={pickedDate}
                setPickedDate={setPickedDate}
                setIsLoaded={setIsLoaded}
                setMonthSwitcher={setMonthSwitcher}
                isParent={true}
            />
        </Stack>
    }
        {!user?.dinneyroles.includes(process.env.REACT_APP_DINNEY_ROLE_PARENT) &&
        <Container fluid className={'my-4'}>
            {isMobile ?
            <>
                <Row className='mb-3'>
                    <MonthPickerComponent 
                        pickedDate ={pickedDate}
                        setPickedDate={setPickedDate}
                        setIsLoaded={setIsLoaded}
                        setMonthSwitcher={setMonthSwitcher}
                        isParent={false}
                    />
                </Row>
                <Row>
                    <FilterComponent 
                        customersList={customersList} 
                        setCount={setCount} 
                        setFilteredCustomersList={setFilteredCustomersList}
                        setPage={setPage} />
                </Row>
            </>
            :
            <>
            <Row>
                <MonthPickerComponent 
                    pickedDate ={pickedDate}
                    setPickedDate={setPickedDate}
                    setIsLoaded={setIsLoaded}
                    setMonthSwitcher={setMonthSwitcher}
                    isParent={false}
                />
                
                <FilterComponent 
                    customersList={customersList} 
                    setCount={setCount} 
                    setFilteredCustomersList={setFilteredCustomersList}
                    setPage={setPage}/>
            </Row>
            </>
            }
            <Row>
                <SendToComponent options={options} 
                    filteredCustomersList = {filteredCustomersList} 
                    pickedDate={pickedDate} 
                    sendStream={SendStream.MEALS_SUMMARY}
                    customerIdsList={customerIdsList}
                    setCustomerIdsList={setCustomerIdsList}
                    />
            </Row>
        </Container>
    }
        <div style={{display: 'flex', justifyContent: 'center'}}>
            <Table size={"sm"} className={'table-custom-style'}>
                {isMobile ?
                <thead>
                    <tr>
                        <th className='text-right'><Chip className={'customTextColor mx-2'} label ={`Łącznie: ${billingTotalAmount} zł`} /></th>
                    </tr>
                </thead>
                :
                <thead>
                <tr>
                        <th className='customTextColor'>#</th>
                        <th className='customTextColor'>Dane rodzica</th>
                        <th className='text-right' colSpan={5}><Chip className={'customTextColor mx-2'} label ={`Łączna kwota za posiłki w tym miesiącu: ${billingTotalAmount} zł (łącznie posiłków: ${billingTotal})`} /></th>
                    </tr>
                </thead>
                }
                
                <tbody>
                {filteredCustomersList !== undefined && filteredCustomersList.length > 0
                    ?
                        filteredCustomersList
                        .filter((customer: Customer, index: number) => {
                            return index >= (page * 10) - 10 && index < page * 10
                        })
                            .map((customer: Customer, index: number) => (
                                <MealSelectionForSingleCustomerComponent
                                    key={index}
                                    index={index}
                                    customer={customer}
                                    page={page}
                                    pickedDate={pickedDate}
                                    setBillingTotal={setBillingTotal}
                                    setBillingTotalAmount={setBillingTotalAmount}
                                    filteredCustomersList={filteredCustomersList}
                                    customerIdsList={customerIdsList}
                                    setCustomerIdsList={setCustomerIdsList}/>
                            ))
                    :
                        <tr>
                            <td colSpan={7}>
                                <Empty
                                    description={<>{`${customersList.length > 0 ? `Nic nie znaleziono` : `Nie dodano jeszcze rodzica`}`}</>}
                                    className='my-4'/>
                            </td>
                        </tr>
                }
                </tbody>
            </Table>
        </div>
        <Stack spacing={2} alignItems={isMobile ? "left" : "center"} justifyContent="center">
            <Pagination count={count} defaultPage={1} page={page} boundaryCount={2} onChange={(e, v) => {window.scrollTo(0, 0); setPage(v)}} size="large" variant="outlined" color="secondary"/>
        </Stack>
        <MealDateWeekSelectionComponent pickedDate ={pickedDate} setPickedDate={setPickedDate}/>
    </>
    )
}